import React, { useLayoutEffect, useRef, useState } from 'react';

// Animates height changes of its content (CSS can't transition height: auto).
// The centered modal re-centers smoothly along with it.
const AutoHeight = ({ children }) => {
  const inner = useRef(null);
  const [height, setHeight] = useState();
  useLayoutEffect(() => {
    const ro = new ResizeObserver(([entry]) => setHeight(entry.target.offsetHeight));
    ro.observe(inner.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div style={{ height, overflow: 'hidden', transition: 'height 250ms ease' }}>
      <div ref={inner}>{children}</div>
    </div>
  );
};

export default AutoHeight;
